<template>
    <SfSection
        v-if="columnLeftContent || columnRightContent"
        layout="2-columns"
    >
        <div v-if="columnLeftContent" v-html="columnLeftContent" class="article" /> <!-- eslint-disable-line -->
        <div v-if="columnRightContent" v-html="columnRightContent" class="article" /> <!-- eslint-disable-line -->
    </SfSection>
</template>

<script>
import { get } from 'lodash-es';
import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';

export default {
    components: {
        SfSection
    },

    mixins: [
        contentBlockMixin
    ],

    computed: {
        columnLeftContent() {
            return get(this, 'block.wysiwyg', '');
        },
        columnRightContent() {
            return get(this, 'block.wysiwyg2', '');
        }
    }
};
</script>
